import React from 'react';
import { MessageSquareIcon, ShoppingCartIcon } from 'lucide-react';
const Slide1 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2473">
      <div className="flex flex-col space-y-6" data-id="element-2474">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center text-indigo-600" data-id="element-2475">
          Omnichannel AI that sells.
        </h2>
        {/* Subtitle and text */}
        <div className="max-w-3xl mx-auto text-center" data-id="element-2476">
          <p className="text-xl font-medium text-gray-800 mb-4" data-id="element-2477">
            We turn catalogs into guided conversations across every channel.
          </p>
          <p className="text-lg text-gray-700 mb-2" data-id="element-2478">
            Focus on AI Sales Advisors first; support optional.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 my-6" data-id="element-2479">
            <h3 className="font-semibold text-amber-800 mb-2" data-id="element-2480">
              Why it matters:
            </h3>
            <p className="text-gray-700" data-id="element-2481">
              clear, need-led guidance → higher conversion & AOV.
            </p>
          </div>
        </div>
        {/* Visualization */}
        <div className="mt-8 max-w-xl mx-auto" data-id="element-2482">
          <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200" data-id="element-2483">
            <div className="flex gap-6" data-id="element-2484">
              {/* Chat UI */}
              <div className="flex-grow" data-id="element-2485">
                <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-2486">
                  <div className="flex justify-between items-center mb-4" data-id="element-2487">
                    <h3 className="font-semibold text-gray-800" data-id="element-2488">
                      AI Shopping Advisor
                    </h3>
                    <div className="w-3 h-3 bg-green-500 rounded-full" data-id="element-2489"></div>
                  </div>
                  <div className="space-y-3 mb-4" data-id="element-2490">
                    <div className="flex items-start gap-2" data-id="element-2491">
                      <div className="bg-indigo-100 rounded-full p-1.5 flex-shrink-0" data-id="element-2492">
                        <MessageSquareIcon className="h-4 w-4 text-indigo-600" data-id="element-2493" />
                      </div>
                      <div className="bg-indigo-50 rounded-lg p-2 text-sm text-indigo-800" data-id="element-2494">
                        How can I help you find the perfect product today?
                      </div>
                    </div>
                    <div className="flex items-start gap-2 justify-end" data-id="element-2495">
                      <div className="bg-gray-100 rounded-lg p-2 text-sm text-gray-800" data-id="element-2496">
                        I'm looking for a gift for my mom
                      </div>
                      <div className="bg-gray-200 rounded-full p-1.5 flex-shrink-0" data-id="element-2497">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2498">
                          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2499" />
                          <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2500" />
                          <path d="M9 9H9.01" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2501" />
                          <path d="M15 9H15.01" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2502" />
                        </svg>
                      </div>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-2503">
                      <div className="bg-indigo-100 rounded-full p-1.5 flex-shrink-0" data-id="element-2504">
                        <MessageSquareIcon className="h-4 w-4 text-indigo-600" data-id="element-2505" />
                      </div>
                      <div className="bg-indigo-50 rounded-lg p-2 text-sm text-indigo-800" data-id="element-2506">
                        Great! What's the occasion and what does she like?
                      </div>
                    </div>
                  </div>
                  <div className="relative" data-id="element-2507">
                    <input type="text" placeholder="Type your message..." className="w-full border border-gray-200 rounded-full py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-2508" />
                    <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-indigo-600 text-white rounded-full p-1.5" data-id="element-2509">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2510">
                        <path d="M22 2L11 13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2511" />
                        <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2512" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              {/* Cart icon */}
              <div className="flex items-start" data-id="element-2513">
                <div className="bg-white p-3 rounded-lg border border-gray-200 relative" data-id="element-2514">
                  <ShoppingCartIcon className="h-6 w-6 text-indigo-600" data-id="element-2515" />
                  <div className="absolute -top-2 -right-2 bg-indigo-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold" data-id="element-2516">
                    2
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide1;